import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0a691627"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = {
  class: "course"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "课程：", -1));

const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = {
  class: "semester"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "学期：", -1));

const _hoisted_9 = {
  class: "text"
};
const _hoisted_10 = {
  class: "chapter"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "章节：", -1));

const _hoisted_12 = {
  class: "text"
};
const _hoisted_13 = {
  class: "bottom"
};
const _hoisted_14 = {
  class: "left"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "right"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "查看数", -1));

export default /*#__PURE__*/_defineComponent({
  props: {
    caseData: {
      type: Object
    }
  },

  setup(__props) {
    const props = __props;
    const menuInfo = inject('menuInfo');

    const goCaseDetail = () => {
      const {
        site_id
      } = props.caseData;
      const menuId = menuInfo.value.menu_id;
      window.open(`/caseDetail.html?siteId=${site_id}&status=0&menuId=${menuId}`, '_blank');
    };

    return (_ctx, _cache) => {
      return __props.caseData ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "list-item",
        onClick: goCaseDetail
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.caseData.case_name), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(__props.caseData.course_name), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(__props.caseData.term_name), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(__props.caseData.outline_name), 1)])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(__props.caseData.teacher_name) + " ", 1), __props.caseData.title ? (_openBlock(), _createElementBlock("span", _hoisted_15, "·" + _toDisplayString(__props.caseData.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, _toDisplayString(__props.caseData.organ_name), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, _toDisplayString(__props.caseData.watch_num), 1), _hoisted_17])])])) : _createCommentVNode("", true);
    };
  }

});